import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import Button from '../UI/Button';
import CardAdmin from '../UI/CardAdmin';
import QRCodeBox from '../UI/QRCodeBox';

const ProductDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { logout } = useUser();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
	

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await fetchWithAuth(
                    `${process.env.REACT_APP_API_URL}/products/${id}`,
                    {},
                    logout
                );
                const data = await response.json();
                setProduct(data.product);
            } catch (err) {
                setError('Ошибка загрузки продукта');
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [id, logout]);

    if (loading) return <div>Загрузка...</div>;
    if (error) return <div className="text-red-500">{error}</div>;
    if (!product) return <div>Продукт не найден</div>;

    return (
        <div className="container mx-auto p-4 text-gray-400">
            <CardAdmin title="Информация о продукте">
                <div className="space-y-6">
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <h3 className="text-lg text-white font-semibold mb-2">Артикул</h3>
                            <p>{product.article}</p>
                        </div>
                        <div>
                            <h3 className="text-lg text-white font-semibold mb-2">Название</h3>
                            <p>{product.name}</p>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg text-white font-semibold mb-2">Описание</h3>
                        <p>{product.description}</p>
                    </div>

					<div className="grid grid-cols-2 gap-4">

						<div>
							<h3 className="text-lg text-white font-semibold mb-2">Вариации</h3>
							{product.variations && product.variations.length > 0 && (
								<div>
									{product.variations.map((variation, index) => (
                                    <div key={variation._id || index} className="mb-4">
                                        <h4 className="font-medium">{variation.key}</h4>
                                        <ul className="list-disc list-inside">
                                            {variation.value.map((value, i) => (
                                                <li key={i}>{value}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    ))}
                                </div>
                            )}
					    </div>

						<div>
							<h3 className="text-lg text-white font-semibold mb-2">QR код</h3>
							<div className="flex justify-center">
                                <QRCodeBox 
                                    qrCodePath={product.qrCodePath}
                                    type="product"
                                    objectId={product._id}
                                    withActions 
                                    className="w-36 h-36"
                                />
                            </div>
                    	</div>

					</div>
                    {product.route && product.route.length > 0 && (
                        <div>
                            <h3 className="text-lg text-white font-semibold mb-2">Маршрут производства</h3>
                            {product.route.map((phase, index) => (
                                <div key={phase._id || index} className="mb-4 p-4 border rounded bg-[#2D2D30] border-[#3E3E42]">
                                    <h4 className="font-medium mb-2">{phase.name}</h4>
                                    <div className="ml-4">
                                        {phase.steps.map((step, stepIndex) => (
                                            <div key={stepIndex} className="mb-2">
                                                <p><span className="font-medium">Шаг:</span> {step.name}</p>
                                                <p><span className="font-medium">Длительность:</span> {step.duration} мин</p>
                                                <p><span className="font-medium">Должность:</span> {step.roleRequired}</p>
                                                <p><span className="font-medium">Оборудование:</span> {step.station}</p>
                                                <p><span className="font-medium">Можно параллелить:</span> {step.canBeSplit ? 'Да' : 'Нет'}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="flex justify-end gap-2">
                        <Button onClick={() => navigate('/products')} variant="secondary">
                            Назад
                        </Button>
                    </div>
                </div>
            </CardAdmin>
        </div>
    );
};

export default ProductDetailPage; 